import { render } from "./SupplyChainPage.vue?vue&type=template&id=6263925d"
import script from "./SupplyChainPage.vue?vue&type=script&lang=js"
export * from "./SupplyChainPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__